import { apiClient } from "./client";

export const getLeadStats = () => apiClient.get("/leads/stats").then((r) => r.data);
